/**
 * One env config file to rule them all
 */
export const ENV_CONFIG = {
  //* Client env variables
  WEB_URL: process.env.NEXT_PUBLIC_WEB_URL,
  DIRECTUS_URL: process.env.NEXT_PUBLIC_DIRECTUS_URL,
  CONSUMER_GATEWAY_URL: process.env.NEXT_PUBLIC_CONSUMER_GATEWAY_URL,
  CONSUMER_TRACKING_API_URL: process.env.NEXT_PUBLIC_CONSUMER_TRACKING_API_URL,
  //* Server env variables
  CONSUMER_GATEWAY_USERNAME: process.env.CONSUMER_GATEWAY_USERNAME,
  CONSUMER_GATEWAY_PASSWORD: process.env.CONSUMER_GATEWAY_PASSWORD,
} as const
